import Vue from "vue";
import CXMApiClient from "../../CXMApiClient";

function initialState() {
  return {
    RuleDeactivationModal: {
      Type: "deactivation", // send "archive" for archiving a rule
      ShowModal: false,
      RuleName: null,
      RuleId: null,
      RuleStatus: {
        Customers: 0,
        OpenTasks: 0,
        OverdueTasks: 0
      },
      RuleGroupId: null
    },
    RuleActivationModal: {
      Type: "activation", // send "unarchive" for unarchiving a rule
      ShowModal: false,
      RuleName: null,
      RuleId: null
    },
    RuleReseedModal: {
      ShowModal: false,
      PlatformId: null,
      IsSoldFollowUp: false,
      IsLeaseFollowUp: false,
      ReseedInfo: null
    }
  };
}

const state = initialState();

const getters = {};

const actions = {
  openRuleDeactivationModal(context, ruleData) {
    // TODO: Get open and overdue tasks' count from API
    let cxmApiClient = new CXMApiClient();
    cxmApiClient
      .ProcessRequest(
        "GET",
        `/api/triggerset/${ruleData.Id}/rule_status_counts`
      )
      .then(resp => {
        context.commit("openRuleDeactivationModal", {
          RuleData: ruleData,
          RuleStatus: resp.data && resp.data.data ? resp.data.data : null
        });
      })
      .catch(resp => {
        context.commit("openRuleDeactivationModal", {
          RuleData: ruleData,
          RuleStatus: null
        });
      });
  },
  closeRuleDeactivationModal(context) {
    context.commit("closeRuleDeactivationModal");
  },
  openRuleActivationModal(context, ruleData) {
    context.commit("openRuleActivationModal", ruleData);
  },
  closeRuleActivationModal(context) {
    context.commit("closeRuleActivationModal");
  },
  async deactivateRule(context, requestPayload) {
    return await Vue.http.post(`/pando/pandox/triggers/deactivate/`, requestPayload).catch(err => err.response);
  },
  async activateRule(context, ruleId) {
    return await Vue.http.put(`/pando/pandox/triggers/activate/${ruleId}`).catch(err => err.response);
  },
  async unarchiveRule(context, ruleId) {
    return await Vue.http.put(`/pando/pandox/triggers/unarchive/${ruleId}`).catch(err => err.response);
  },
  openRuleReseedModal(context, data) {
    if (!data.IsSoldFollowUp && !data.IsLeaseFollowUp) return;

    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      let routePath = data.IsSoldFollowUp
        ? "reseedSoldRules"
        : "reseedLeaseRules";

      cxmApiClient
        .ProcessRequest(
          "GET",
          `/api/rulegroup/account_platform/${data.PlatformId}/${routePath}`
        )
        .then(resp => {
          if (resp.data && resp.data.successful) {
            context.commit("openRuleReseedModal", {
              PlatformId: data.PlatformId,
              IsSoldFollowUp: data.IsSoldFollowUp,
              IsLeaseFollowUp: data.IsLeaseFollowUp,
              ReseedInfo: resp.data.data
            });
            resolve(resp);
          } else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  closeRuleReseedModal(context) {
    context.commit("closeRuleReseedModal");
  },
  requestRuleReseed(context) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      let accountId = context.getters.User.ViewAccountID;
      let routePath = state.RuleReseedModal.IsSoldFollowUp
        ? "reseedSoldRules"
        : "reseedLeaseRules";

      cxmApiClient
        .ProcessRequest(
          "PUT",
          `/api/rulegroup/account/${accountId}/account_platform/${state.RuleReseedModal.PlatformId}/${routePath}`
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  }
};

const mutations = {
  openRuleDeactivationModal(state, data) {
    let ruleData = data.RuleData;
    let ruleStatus = data.RuleStatus;
    state.RuleDeactivationModal.RuleName = ruleData.Name;
    state.RuleDeactivationModal.RuleId = ruleData.Id;
    state.RuleDeactivationModal.Type = ruleData.Type;
    state.RuleDeactivationModal.RuleGroupId = ruleData.RuleGroupId;
    state.RuleDeactivationModal.ShowModal = true;

    if (ruleStatus) {
      state.RuleDeactivationModal.RuleStatus.Customers =
        ruleStatus.distinctCustomers;
      state.RuleDeactivationModal.RuleStatus.OpenTasks = ruleStatus.open;
      state.RuleDeactivationModal.RuleStatus.OverdueTasks = ruleStatus.overdue;
    }
  },
  closeRuleDeactivationModal(state) {
    let originalState = initialState();
    Vue.set(
      state,
      "RuleDeactivationModal",
      originalState.RuleDeactivationModal
    );
  },
  openRuleActivationModal(state, ruleData) {
    state.RuleActivationModal.RuleName = ruleData.Name;
    state.RuleActivationModal.RuleId = ruleData.Id;
    state.RuleActivationModal.Type = ruleData.Type;
    state.RuleActivationModal.RuleGroupId = ruleData.RuleGroupId;
    state.RuleActivationModal.ShowModal = true;
  },
  closeRuleActivationModal(state) {
    let originalState = initialState();
    Vue.set(state, "RuleActivationModal", originalState.RuleActivationModal);
  },
  openRuleReseedModal(state, data) {
    state.RuleReseedModal.ShowModal = true;
    state.RuleReseedModal.PlatformId = data.PlatformId;
    state.RuleReseedModal.IsSoldFollowUp = data.IsSoldFollowUp;
    state.RuleReseedModal.IsLeaseFollowUp = data.IsLeaseFollowUp;
    state.RuleReseedModal.ReseedInfo = data.ReseedInfo;
  },
  closeRuleReseedModal(state) {
    let originalState = initialState();
    Vue.set(state, "RuleReseedModal", originalState.RuleReseedModal);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/rules/RuleStatus.js